import { TriggerCreator } from "../services/trigger-creator"
import ProcessStatusView from "@/components/ProcessStatusView"

export default {
    name: 'TriggerView',
    components: {
        ProcessStatusView
    },
    props: [
        "id",
        "triggerData",
        "triggerFile",
        "processStatus"
    ],
    data: function() {
        var data = {
            TriggerCreator: TriggerCreator,
            soapEnvelope: {
                content: null,
                fileName: null,
                useAccessToken: "false"
            }
        };
        return data;
    },
    methods: {
        triggerDelete: function() {
            if (confirm("Really delete this trigger?")) {
                this.$emit("Trigger:delete", this.id);
            }
        }
    }
}